import { render } from "./permission.vue?vue&type=template&id=06fa87e9"
import script from "./permission.vue?vue&type=script&lang=js"
export * from "./permission.vue?vue&type=script&lang=js"

import "./permission.vue?vue&type=style&index=0&id=06fa87e9&lang=scss"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__